import { supabase } from '../clients/supabaseClient';

export type CreateUserPayload = {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    cellphone: string;
    role: 'user' | 'driver';
    car_model?: string;
    number_plate?: string;
    store_id?: string | null;
};

export async function createUserInDb(payload: CreateUserPayload): Promise<void> {
    // Check phone uniqueness before auth signup
    const { data: existing } = await supabase
        .from('profiles')
        .select('id')
        .eq('cellphone', payload.cellphone.trim())
        .maybeSingle();

    if (existing) {
        throw new Error(`A user with phone number ${payload.cellphone} already exists.`);
    }

    const { data: authData, error: authError } = await supabase.auth.signUp({
        email:    payload.email,
        password: payload.password,
    });

    if (authError) throw authError;
    if (!authData?.user) throw new Error('Auth signup returned no user');

    const { error: profileError } = await supabase
        .from('profiles')
        .insert({
            id:         authData.user.id,
            first_name: payload.first_name,
            last_name:  payload.last_name,
            cellphone:  payload.cellphone.trim(),
            is_admin:   false,
            role:       payload.role,
        });

    if (profileError) {
        if (profileError.code === '23505') {
            throw new Error(`A user with phone number ${payload.cellphone} already exists.`);
        }
        throw profileError;
    }

    if (payload.role === 'driver') {
        const { error: driverError } = await supabase
            .from('drivers')
            .insert([{
                driver_name:  `${payload.first_name} ${payload.last_name}`,
                auth_id:      authData.user.id,
                car_model:    payload.car_model ?? '',
                number_plate: payload.number_plate ?? '',
                store_id:     payload.store_id ?? '',
            }]);

        if (driverError) throw driverError;
    }
}